import { useEffect, useState } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { Html } from '@react-three/drei';

export function PerfToggles() {
  const [fps, setFps] = useState(0);
  const [frameTime, setFrameTime] = useState(0);
  const [drawCalls, setDrawCalls] = useState(0);
  const { gl } = useThree();

  // Track FPS
  useEffect(() => {
    let frames = 0;
    let lastTime = performance.now();

    const measure = () => {
      frames++;
      const now = performance.now();
      const delta = now - lastTime;

      if (delta >= 1000) {
        setFps(Math.round((frames * 1000) / delta));
        setFrameTime(Math.round(delta / frames * 100) / 100);
        frames = 0;
        lastTime = now;
      }

      requestAnimationFrame(measure);
    };

    const handle = requestAnimationFrame(measure);
    return () => cancelAnimationFrame(handle);
  }, []);

  // Get renderer stats each frame
  useFrame(() => {
    const info = gl.info;
    setDrawCalls(info.render.calls);
  });

  return (
    <Html
      position={[0, 0, 0]}
      style={{
        position: 'fixed',
        top: '8px',
        left: '8px',
        background: 'rgba(0, 0, 0, 0.8)',
        padding: '8px 12px',
        borderRadius: '4px',
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: '11px',
        color: '#00ff88',
        lineHeight: 1.6,
        pointerEvents: 'none',
        minWidth: '140px',
        zIndex: 9999,
      }}
      calculatePosition={() => [8, 8, 0]}
      prepend
      center={false}
    >
      <div>FPS: <span style={{ color: fps < 30 ? '#ff4757' : fps < 55 ? '#ffa502' : '#00ff88' }}>{fps}</span></div>
      <div>Frame: {frameTime}ms</div>
      <div>Draws: {drawCalls}</div>
    </Html>
  );
}
